import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, Observable, forkJoin } from 'rxjs';
import { FunctionsService } from 'src/app/___LOGIC/__common/functions.service';
import { DataProviderService } from 'src/app/___LOGIC/__data/data-provider.service';
import { FileService } from 'src/app/___LOGIC/___common/__files/file.service';
import { GuiFlowService } from 'src/app/___LOGIC/__gui/gui-flow.service';
import { OmnibusContract } from 'src/app/___LOGIC/___common/__interfaces/OmnibusContract';
import { TranslationService } from 'src/app/___LOGIC/___common/__language/translation.service';
import { NavigationService } from 'src/app/___LOGIC/__navigation/navigation.service';
import { OrdersService } from 'src/app/___LOGIC/__orders/orders.service';
import { ShopifyService } from 'src/app/___LOGIC/__shopify/shopify.service';
import { TermsPolicyService } from 'src/app/___LOGIC/terms-policy.service';
import { OmnibusService } from 'src/app/___LOGIC/omnibus.service';
import { environment } from 'src/environments/environment';
import { ConfigService } from 'src/app/___LOGIC/___common/__config/config.service';
import { EmailService } from 'src/app/___LOGIC/__email/email.service';

const SEGURO_MEDICO_ID_BD =58;
const SEGURO_MEDICO_SHOPIFY_VARIANT_ID =51051369300271;

@Component({
  selector: 'app-medical-insurance',
  templateUrl: './medical-insurance.component.html',
  styleUrls: ['./medical-insurance.component.css']
})
export class MedicalInsuranceComponent implements OnInit {

  debug = environment.debugMode;
  testing = environment.testingMode;

  emailForm: FormGroup;
  pollingSubscription!: Subscription;
  status = '';
  loading = false;
  //
  policyChecked = false;
  termsChecked = false;
  policyCheckLabel = 'Al enviar este formulario, declaro haber leído y aceptado la Política de Privacidad y consiento expresamente el tratamiento de mis datos personales, incluidos los de categoría especial, con la finalidad de gestionar mi solicitud de seguro médico y otros servicios relacionados prestados por VoyJaleas en colaboración con la correduría Rosillo Hermanos Correduría de Seguros S.A.';
  termsAndConditionsLabel = 'He leído y acepto los Términos y Condiciones de Servicio de VoyJaleas.';
  
  failedUploads = [];

  formData: { [key: string]: any } = {};
  // FORMS
  seguroForm: FormGroup;
  studentForm: FormGroup;
  //VARIABLES FOR LOAD WITH TOKEN
  studentInfo;
  omnibusContract: OmnibusContract;
  // HELP
  passportHelp = false;
  //
  lastStudentInserted;
  lastOrderCode;
  token;

  // CURRENT STEP IN THE PROCESS
  processStatus = 0;
  // SELECTORES
  meses = [];
  duraciones = [];
  //STEPS
  steps = [];

  // LOADING MODAL
  loadingModal = false;
  loadingStep: 'spinner' | 'confirmation' = 'spinner';
  loadingMessage = 'Procesando, por favor espera...';
  confirmationText = '¡Proceso completado con éxito!';
  nextSectionId = 'step0'; // dynamic target section ID

  @ViewChild('step1') step1: ElementRef;
  @ViewChild('step2') step2: ElementRef;
  @ViewChild('step3') step3: ElementRef;
  @ViewChild('step4') step4: ElementRef;
  @ViewChild('step5') step5: ElementRef;
  @ViewChild('step6') step6: ElementRef;
  @ViewChild('step7') step7: ElementRef;
  @ViewChild('step8') step8: ElementRef;
  @ViewChild('step9') step9: ElementRef;
  @ViewChild('step10') step10: ElementRef;

  constructor(private fb: FormBuilder,private translationService: TranslationService,private emailService: EmailService,private ordersService: OrdersService,private shopifyService: ShopifyService,private fileService: FileService,private http: HttpClient,private guiFlow: GuiFlowService,private commonFunctions: FunctionsService,private route:ActivatedRoute,private router: Router,private dataProvider: DataProviderService,private cdr: ChangeDetectorRef,private navigationService: NavigationService,private termsAndPolicyService: TermsPolicyService,private omnibusService: OmnibusService,private configService: ConfigService) {
    this.emailForm = this.fb.group({email: [this.testing ? this.emailService.getAdminEmail() : '', [Validators.required, Validators.email]]});
  }

  ngOnInit(): void {
    // SELECTORES
    this.meses = this.dataProvider.getMesesAnio();
    this.duraciones = this.dataProvider.getDuracionesSeguroMeses();
    // STEPS
    this.steps = this.dataProvider.getStepsSeguroMedico();
    // FORMS
    this.seguroForm = this.omnibusService.buildSeguroForm(this.debug);
    this.studentForm = this.omnibusService.buildStudentForm(this.debug);
    // LOAD
    this.loadComponent();
  }
  
  loadComponent(){
    //Process URL
    if(this.route.snapshot.paramMap.get('token')){
      this.load();
    }else{
      if(this.commonFunctions.getSelectedClientId()){
        this.showSpinnerModal('Cargando...');
        this.http.get(this.configService.getApiUrlRefactor('appGet')+'?queryId=getOmnibusContractInfoByClient&queryParam1='+this.commonFunctions.getSelectedClientId())
        .subscribe(
          (response) => {
            if(response['records']){
              debugger
              this.omnibusContract = response['records'];
              this.loading = false;
              this.nextSectionId = 'step1';
              this.processStatus = parseInt(this.omnibusContract.status);
              this.hideModal();
            }else{
             /*  this.guiFlow.openSimpleSnackBar('Error: contacte al administrador','error',null,null); 
              console.log('No hay omnibus contract para ese cliente'); */
            }
          },
          (error) => {
    /*         this.initContractObj(null);
            this.guiFlow.openSimpleSnackBar('Error','error',null,null);            
            console.log(error);
            this.loading = false; */
          }
        )
      }else{
        this.initContractObj(null);
      }
    }
  }

  async load(){
    let url = this.configService.getApiUrlRefactor('appBase')+"subapps/check_health_token.php?token="+this.route.snapshot.paramMap.get('token');
    const data = await this.http.get(url).toPromise();
    if(data['OK'] && data['OK'].contract){
      this.omnibusContract = data['OK'].contract;
      this.lastStudentInserted = this.omnibusContract['FK_ID_student'];
      this.processStatus = parseInt(this.omnibusContract.status);
      this.nextSectionId = 'step'+(this.processStatus+1);
      this.loadStudentInfo();
    }else{
      this.guiFlow.openSimpleSnackBar('Contacta al admin','error',null, '');
    }
  }

  initContractObj(loadObj){
    if(loadObj){
        const result = this.omnibusService.calculateDates(loadObj.mesInicio, loadObj.anioInicio, loadObj.duracionCurso);
        this.omnibusContract.monthsDuration = loadObj.duracionCurso || null;
        this.omnibusContract.startDate = result.startDate || null;
        this.omnibusContract.endDate = result.endDate || null;
        this.lastStudentInserted? this.omnibusContract.FK_ID_student = this.lastStudentInserted : null;
    }else{
      this.omnibusContract = {
        id: '-1',
        token: null
      };
    }
  }

  ngAfterViewInit() {
    // Map fragments to ViewChild elements
    const sectionMap: { [key: string]: ElementRef<HTMLDivElement> } = {
      step1: this.step1,
      step2: this.step2,
      step3: this.step3,
      step4: this.step4,
      step5: this.step5,
      step6: this.step6,
      step7: this.step7,
      step8: this.step8,
      step9: this.step9,
      step10: this.step10
    };
    // Call the shared service to handle scrolling
    this.navigationService.scrollToFragment(this.route, sectionMap);
  }

  showSpinnerModal(message?: string){
    this.loadingModal = true;
    this.loadingStep = 'spinner';
    this.loadingMessage = message;
  }

  loadStudentInfo(){
    this.omnibusService.getStudentInfo(this.omnibusContract.id).subscribe(
      (response) => {
        this.studentInfo = response['records'];
        // Set values later
        this.studentForm.patchValue({
          name: this.studentInfo['name']? this.studentInfo['name'] : '',
          lastname1: this.studentInfo['lastname1']? this.studentInfo['lastname1'] : '',
          lastname2: this.studentInfo['lastname2']? this.studentInfo['lastname2'] : '',
          birthDate: this.studentInfo['birthDate']? this.studentInfo['birthDate'] : '',
          gender: this.studentInfo['gender']? this.studentInfo['gender'] : '',
          passportNumber: this.studentInfo['passportNumber']? this.studentInfo['passportNumber'] : '',
          address: this.studentInfo['address']? this.studentInfo['address'] : '',
          country: this.studentInfo['country']? this.studentInfo['country'] : '',
          email: this.studentInfo['email']? this.studentInfo['email'] : '',
          phone: this.studentInfo['phone']? this.studentInfo['phone'] : '',
          university: this.studentInfo['university']? this.studentInfo['university'] : '',
        });
        this.onLoadingModalClosed('step'+(this.processStatus+1));
      },
      (error) => {
        console.log(error);
      }
    );
  }

  isStepVisible(step){
    return this.processStatus == step;
  }

  localSaveFile(event: { fileId: string; file: File }) {
    this.fileService.saveFileInLocal(event);
  }

  // VALIDATING UPLOAD MODALS
  areFilesUploaded(){
    switch(this.processStatus){
      case 3:
        return this.fileService.isFileUploaded('passport') && this.fileService.isFileUploaded('cartaAceptacion');
      case 6:
        return this.fileService.isFileUploaded('formularioRelleno') && this.fileService.isFileUploaded('cuestionarioRelleno');
      default:
        return false;
    }
  }

  isLoading(){
    return this.loading;
  }

  isEmailInfoSent(){
    return this.omnibusService.isEmailInfoSent();
  }

  getTranslationFor(label){
    return this.translationService.getTranslatedText(label);
  }

  checkIsOrderProcessed(orderId){
    this.showSpinnerModal('Procesando orden');
    this.ordersService.checkIsOrderProcessed(orderId).subscribe({
      next: (result) => {
        if (result && result.status === 'paid') {
          this.processStatus = 1;
          this.lastOrderCode = result.orderData.orderCode;
          this.status = 'paid';
          if (result.orderData.FK_ID_clientDetails) {
            this.showPaymentReceivedModal();
            this.loadCurrentContractInfo(result.orderData.FK_ID_clientDetails);
          } else {
            console.log('Error, no client associated to this purchase');
          }
        }
      },
      error: (err) => {
        console.error('Payment failed or timed out:', err);
      }
    });
  }

  showPaymentReceivedModal(){
    this.loadingModal = true;
    this.loadingStep = 'confirmation';
    this.confirmationText = 'Pago recibido';
  }

  hideModal(){
    this.loadingModal = false;
  }

  loadCurrentContractInfo(clientId){
    this.http.get(this.configService.getApiUrlRefactor('appGet')+'?queryId=getOmnibusContractInfoByClient&queryParam1='+clientId)
        .subscribe(
          (response) => {
            if(response['records']){
              this.omnibusContract = response['records'];
              this.loading = false;
              this.nextSectionId = 'step1';
              setTimeout(() => {
                this.hideModal();
              }, 2000); // 3 seconds
            }else{
              this.guiFlow.openSimpleSnackBar('Error: contacte al administrador','error',null,null); 
              console.log('No hay omnibus contract para ese cliente');
            }
          },
          (error) => {
            this.initContractObj(null);
            this.guiFlow.openSimpleSnackBar('Error','error',null,null);            
            console.log(error);
            this.loading = false;
          }
        )
  }

  isStatus(status){
    return this.status == status;
  }

  buyProduct(myVariantLabel){
    this.status = 'processing';
    this.ordersService.buyProduct(myVariantLabel).subscribe({
      next: (response) => {
        if (response && response.OK) {
          let orderObject = {
            'productVariantId': SEGURO_MEDICO_SHOPIFY_VARIANT_ID
          };
          response.OK.records.FK_ID_clientDetails? orderObject['user_id'] = response.OK.records.FK_ID_clientDetails : null; // In case user is logged in
          this.shopifyService.buyProduct(orderObject);
          this.checkIsOrderProcessed(response.OK.records.orderCode);
        } else {
          console.warn('Order creation failed:', response);
          // Handle case where API returns success: false
        }
      },
      error: (error) => {
        this.guiFlow.openSimpleSnackBar('Error, intentalo de nuevo','error',null,'');
        console.error('HTTP request failed:', error);
        if (error.status === 0) {
          console.error('Likely CORS error or Network issue');
        } else {
          console.error(`Error ${error.status}: ${error.message}`);
        }
      }
    })
  }

  /* STEP 1 - INFO SEGURO */
  saveInsuranceData() {
    if (this.debug || this.seguroForm.valid) {
      this.loading = true;
      this.showSpinnerModal('Guardando');
      // si hay token es mas fácil
      if(this.omnibusContract.token && this.omnibusContract.token.length>0){
        this.processInsuranceDataSaved();
      }else{
        // si no hay token
        // tengo que saber cual fue el último omnibusContract que se guardó
        const variantId = this.dataProvider.getShopifyProductValueByField('variantId', 'id', SEGURO_MEDICO_ID_BD);
        this.http.get(this.configService.getApiUrlRefactor('appGet')+'?queryId=getProductByVariantAndOrderCode&queryParam1='+variantId+'&queryParam2='+this.lastOrderCode)
        .subscribe(
          (response) => {
            if(response['records'] && response['records'].FK_ID_lastInserted){
              this.omnibusContract.id = response['records'].FK_ID_lastInserted;
              this.processInsuranceDataSaved();
            }else{
              this.guiFlow.openSimpleSnackBar('Error: contacte al administrador','error',null,null); 
            }
          },
          (error) => {
            this.guiFlow.openSimpleSnackBar('Error','error',null,null);            
            console.log(error);
            this.hideModal();
          }
        )
      }
    }
  }

  processInsuranceDataSaved(){
    // create student and update FK_ID_student and other omnibusContract details
    this.omnibusService.createStudentRow({university: this.seguroForm.value.university || null}).subscribe(
      (response) => {
        if(response && response['OK'] && response['OK']['records']){
          this.lastStudentInserted = response['OK']['records']['id'];
          this.initContractObj(this.seguroForm.value);

          this.omnibusService.updateContractInfo(this.omnibusContract.id,this.omnibusContract).subscribe(
            (response) => {
              this.goToNextStep();
            },
            (error) => {
              console.error('Error updating contract consent row', error);
            }
          );
        }else{
          console.error('Error creating consent row', '');
        }
      },
      (error) => {
        console.error('Error creating consent row', error);
      }
    );
  }

  /* STEP 2 - INFO ESTUDIANTE */
  isStudentFormValid(){
    return this.studentForm.valid && this.policyChecked && this.termsChecked;
  }

  saveStudentInfo() {
    if (this.isStudentFormValid() || this.debug) {
      this.showSpinnerModal('Guardando');
      const data = this.studentForm.value;
      const studentData = {
        name: data.name? data.name : null,
        lastname1: data.lastname1? data.lastname1 : null,
        lastname2: data.lastname2? data.lastname2 : null,
        birthDate: data.birthDate? data.birthDate : null,
        gender: data.gender? data.gender : null,
        passportNumber: data.passportNumber? data.passportNumber : null,
        address: data.address? data.address : null,
        country: data.country? data.country : null,
        email: data.email? data.email : null,
        phone: data.phone? data.phone : null
      };

      const contractUpdated = {
        status: this.processStatus+1,
        FK_ID_student: this.lastStudentInserted
      };
      
      const privacyAccepted = {
        accepted: true,
        type: 'privacyPolicy',
        version: this.termsAndPolicyService.getPolicyObjs()['version'],
        consentText: this.termsAndPolicyService.getPolicyObjs()['text'],
        productName: 'omnibusContract',
        FK_ID_productReference: this.omnibusContract.id
      };

      const termsAccepted = {
        accepted: true,
        type: 'termsAndConditions',
        version: this.termsAndPolicyService.getTermsText()['version'],
        consentText: this.termsAndPolicyService.getTermsText()['text'],
        productName: 'omnibusContract',
        FK_ID_productReference: this.omnibusContract.id
      }
      
      // create accepted terms and condition
      this.createConsentRow(privacyAccepted).subscribe(
        (response) => {
          this.createConsentRow(termsAccepted).subscribe(
            (response) => {
              // Wait until both HTTP calls finish
              this.resolveXhrOperations(this.omnibusService.updateContractInfo(this.omnibusContract.id,contractUpdated),this.omnibusService.updateStudentInfo(studentData,this.lastStudentInserted));
            },
            (error) => {
              console.error('Error creating consent row', error);
            }
          );
        },
        (error) => {
          console.error('Error creating consent row', error);
        }
      );
    }
  }

  /* STEP 3 - SUBIR PASAPORTE Y CARTA */
  uploadDocuments(){
    this.uploadOmnibusDocuments(this.omnibusService.getDocumentsToUpload(this.processStatus));
  }

  uploadOmnibusDocuments(documentsToUpload) {
    if (!this.fileService.validateDocsAreAttached(documentsToUpload)) {
      this.guiFlow.openSimpleSnackBar('Por favor sube ambos documentos antes de continuar.', 'info');
      return;
    }
  
    this.loading = true;
    this.loadingModal = true;
  
    this.fileService.uploadDocuments(this.fileService.getLocalSavedFiles(),documentsToUpload,this.processStatus,this.omnibusContract.id).then(results => {
      const failedDocs = results.filter(r => r.status === 'rejected');
      const successfulDocs = results.filter(r => r.status === 'fulfilled');
  
      console.log('✅ Subidos correctamente:', successfulDocs.map(d => d.file_id));
      console.log('❌ Fallaron:', failedDocs.map(d => d.file_id));
  
      if (failedDocs.length === 0) {
        this.guiFlow.openSimpleSnackBar('Documentos subidos correctamente', 'success');
        this.goToNextStep();
      } else {
        this.hideModal();
        const failedFileNames = failedDocs
          .map(d => this.fileService.getDocLabelById(d.file_id))
          .join(', ');
        this.guiFlow.openSimpleSnackBar(
          `Algunos documentos no se subieron: ${failedFileNames}. Por favor vuelve a intentarlo.`,
          'error',
          null,
          ''
        );
        this.loading = false;
        this.failedUploads = failedDocs.map(d => d.file_id);
      }
    });
  }
  
  retryFailedUploads() {
    const docsToRetry = this.failedUploads.map(fileId => ({
      file: this.fileService.getLocalSavedFiles()[fileId],
      file_id: fileId,
      description: 'Intento de reenvío'
    }));
    this.uploadOmnibusDocuments(docsToRetry);
  }

  goToNextStep(){
    const contractUpdated = {
      status: this.processStatus+1
    };
    this.resolveXhrOperations(this.omnibusService.updateContractInfo(this.omnibusContract.id,contractUpdated));
    this.sendNotificationEmails();
  }

  sendNotificationEmails(){
    this.omnibusService.sendNotificationEmails(this.processStatus,this.emailForm.value,this.studentForm.value,this.studentInfo,this.omnibusContract);
  }

  resolveXhrOperations(obs1: Observable<any>): void;
  resolveXhrOperations(obs1: Observable<any>, obs2: Observable<any>): void;
  
  resolveXhrOperations(obs1: Observable<any>, obs2?: Observable<any>): void {
    this.loading = true;
  
    if (obs2) {
      forkJoin([obs1, obs2]).subscribe({
        next: ([res1, res2]) => {
          this.afterPromisesResolved(res1, res2);
          this.loading = false;
        },
        error: (err) => {
          console.error('Error in request:', err);
          this.loading = false;
          this.guiFlow.openSimpleSnackBar('Error', null,null);
        }
      });
    } else {
      obs1.subscribe({
        next: (res1) => {
          this.afterPromisesResolved(res1, null);
          this.loading = false;
        },
        error: (err) => {
          console.error('Error in request:', err);
          this.loading = false;
          this.guiFlow.openSimpleSnackBar('Error', 'error',null,null);
        }
      });
    }
  }
  
  afterPromisesResolved(result1:any,result2:any | null){
    switch(this.processStatus){
      case 0:
        this.processStatus++;
      case 1:
        this.nextSectionId = 'step2';
        break;
      case 2: // 2 - Datos estudiante
        this.nextSectionId = 'step3';
        break;
      case 3: // Subiendo documentos
        this.nextSectionId = 'step4';
        break;
      default:
        break;
    }
    /* console.log('Promise1:', result1);
    console.log('Promise2:', result2); */
    this.guiFlow.openSimpleSnackBar('Datos guardados','success',null,'');
    this.loading = false;
    this.loadingModal = false;
    this.processStatus++;
    this.scrollIntoView(this.nextSectionId);
    }

  createConsentRow(p_consent){
    const createConsent$ = this.http.post(
      this.configService.getApiUrlRefactor('appBase')+'post/create.php?table=termsConsent',
      p_consent
    );
    return createConsent$;
  }

  createTermsRow(p_termsAndConditions){
    const createTerms$ = this.http.post(
      this.configService.getApiUrlRefactor('appBase')+'post/create.php?table=termsConsent',
      p_termsAndConditions
    );
    return createTerms$;
  }

  descargarDocumentos() {
    this.router.navigate(['/download', this.omnibusContract.id]);
  }

  descargarCertificadoPDF(){
    this.router.navigate(['/download-pdf', this.omnibusContract.id]);
  }

  scrollIntoView(selection): void {
    switch(selection){
      case 'step1':
        this.step1.nativeElement.scrollIntoView({ behavior: 'smooth'});
        break;
      case 'step2':
        this.step2.nativeElement.scrollIntoView({ behavior: 'smooth'});
        break;
      case 'step3':
        this.step3.nativeElement.scrollIntoView({ behavior: 'smooth'});
        break;
      case 'step4':
        this.step4.nativeElement.scrollIntoView({ behavior: 'smooth'});
        break;
    }
  }

  nextStep(){
    this.processStatus++;
    this.cdr.detectChanges(); // ensure DOM is updated
    this.nextSectionId = 'step'+(this.processStatus);    
    this.scrollIntoView(this.nextSectionId);
  }
  
  prevStep(){
    this.processStatus--;
  }

  showProgress(){
    return this.processStatus >3 && this.processStatus < 11;
  }

  showCompletedStepDetails(currentStep){
    return (currentStep.id > this.processStatus-1) || ( currentStep.id >= this.processStatus);
  }
  
  summaryStepsVisible(){
    let res = [];
    for(let step of this.steps){
      !this.showCompletedStepDetails(step)? res.push(step) : null;
    }
    return res;
  }

  onLoadingModalClosed(targetStep: string) {
    const element = document.querySelector(`#${this.nextSectionId}`);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
  }

  onPolicyChecked($event){
    this.policyChecked = $event;
  }

  onTermsChecked($event){
    this.termsChecked = $event;
  }

}
